var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFangoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 300,
    viewBox: "0 0 1000 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 500 150)",
    id: "8143c222-8d6b-4bc1-b0e2-467965988171"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(139,33,33)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -500,
    y: -150,
    rx: 0,
    ry: 0,
    width: 1000,
    height: 300
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "119f3ae4-6d33-4ffe-ba43-e2d16aef3194"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.17 0 0 7.17 500 150)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 29.38 1.92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,5,5)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-122.29, -94.96)",
    d: "M 117.441406 82.507812 L 133.9375 82.507812 L 134.050781 82.621094 L 134.050781 85.355469 L 133.882812 85.46875 L 117.625 85.542969 L 116.269531 85.820312 L 115.582031 86.15625 L 114.726562 86.84375 L 113.871094 88.035156 L 113.535156 89.503906 L 113.535156 100.441406 L 113.8125 101.628906 L 114.425781 102.652344 L 115.117188 103.433594 L 115.898438 103.957031 L 116.84375 104.289062 L 117.292969 104.402344 L 131.113281 104.511719 L 130.945312 99.417969 L 130.664062 98.28125 L 130.050781 97.332031 L 129.363281 96.644531 L 128.414062 96.03125 L 127.464844 95.753906 L 126.945312 95.640625 L 119.335938 95.53125 L 119.226562 95.417969 L 119.226562 92.628906 L 127.019531 92.628906 L 128.5625 92.90625 L 129.585938 93.242188 L 130.535156 93.761719 L 131.390625 94.449219 L 132.003906 94.972656 L 133.027344 96.441406 L 133.546875 97.464844 L 133.882812 99.269531 L 133.996094 100.980469 L 133.996094 107.304688 L 133.828125 107.414062 L 117.773438 107.414062 L 116.0625 107.136719 L 114.519531 106.613281 L 113.738281 106.09375 L 112.546875 105.070312 L 111.824219 104.214844 L 111.136719 103.027344 L 110.6875 101.722656 L 110.519531 100.53125 L 110.519531 89.132812 L 110.6875 88.183594 L 111.023438 87.046875 L 111.636719 85.914062 L 112.25 85.132812 L 112.9375 84.351562 L 113.960938 83.570312 L 115.320312 82.882812 L 116.679688 82.546875 Z M 117.441406 82.507812",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4 1.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,5,5)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-96.91, -94.97)",
    d: "M 85.167969 82.507812 L 88.515625 82.507812 L 89.371094 83.53125 L 89.894531 84.222656 L 90.84375 85.355469 L 91.53125 86.210938 L 92.480469 87.34375 L 93.167969 88.203125 L 94.191406 89.390625 L 94.804688 90.171875 L 95.753906 91.308594 L 96.367188 92.089844 L 97.390625 93.277344 L 98.171875 94.226562 L 99.304688 95.585938 L 100.085938 96.535156 L 101.222656 97.890625 L 102.246094 99.082031 L 102.859375 99.863281 L 103.882812 101.054688 L 104.402344 101.742188 L 105.183594 102.597656 L 105.628906 103.210938 L 105.910156 103.324219 L 105.796875 103.15625 L 105.796875 82.621094 L 105.910156 82.507812 L 108.734375 82.507812 L 108.734375 107.265625 L 108.121094 107.433594 L 105.292969 107.433594 L 104.511719 106.410156 L 103.566406 105.277344 L 102.617188 104.085938 L 101.59375 102.894531 L 100.457031 101.539062 L 99.4375 100.347656 L 98.746094 99.492188 L 97.613281 98.132812 L 96.664062 96.941406 L 95.640625 95.753906 L 94.691406 94.617188 L 94.003906 93.761719 L 92.871094 92.40625 L 92.089844 91.457031 L 91.140625 90.320312 L 90.359375 89.371094 L 89.410156 88.238281 L 88.460938 87.046875 L 88.015625 86.601562 L 88.015625 107.265625 L 86.546875 107.378906 L 85.1875 107.378906 L 85.078125 107.265625 L 85.078125 82.621094 Z M 85.167969 82.507812",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.76 1.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,5,5)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-147.67, -95.03)",
    d: "M 143.050781 82.507812 L 152.539062 82.507812 L 153.730469 82.675781 L 154.863281 83.011719 L 155.886719 83.53125 L 157.019531 84.386719 L 158.042969 85.410156 L 158.65625 86.359375 L 159.105469 87.382812 L 159.4375 88.742188 L 159.550781 89.875 L 159.550781 99.957031 L 159.273438 101.464844 L 158.992188 102.484375 L 158.304688 103.957031 L 157.691406 104.738281 L 156.742188 105.757812 L 155.609375 106.539062 L 154.585938 106.988281 L 153.804688 107.265625 L 152.613281 107.433594 L 151.421875 107.546875 L 143.574219 107.546875 L 141.601562 107.378906 L 140.300781 106.929688 L 138.941406 106.148438 L 138.085938 105.367188 L 137.472656 104.753906 L 136.859375 103.804688 L 136.171875 102.335938 L 135.890625 101.203125 L 135.78125 100.347656 L 135.78125 89.761719 L 135.949219 88.292969 L 136.394531 86.824219 L 137.082031 85.523438 L 138.03125 84.5 L 138.8125 83.8125 L 140.113281 83.03125 L 141.65625 82.507812 Z M 142.699219 85.429688 L 141.675781 85.707031 L 140.726562 86.230469 L 139.777344 87.085938 L 139.332031 87.699219 L 138.886719 89 L 138.886719 100.941406 L 139.222656 102.078125 L 139.835938 103.027344 L 140.28125 103.472656 L 140.894531 103.992188 L 141.84375 104.4375 L 142.625 104.605469 L 152.964844 104.605469 L 153.988281 104.273438 L 154.769531 103.75 L 155.457031 103.136719 L 156.074219 102.1875 L 156.40625 101.332031 L 156.574219 100.03125 L 156.574219 89.894531 L 156.40625 88.703125 L 156.074219 87.753906 L 155.457031 86.972656 L 154.84375 86.359375 L 153.542969 85.671875 L 152.242188 85.394531 L 142.679688 85.394531 L 142.679688 85.429688 Z M 142.699219 85.429688",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -54.89 1.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(5,5,5)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-38.02, -95.03)",
    d: "M 33.109375 82.507812 L 49.773438 82.507812 L 49.773438 85.335938 L 49.605469 85.449219 L 33.109375 85.558594 L 32.085938 85.839844 L 31.304688 86.171875 L 30.617188 86.789062 L 29.925781 87.570312 L 29.40625 88.703125 L 29.296875 89.039062 L 29.183594 92.273438 L 29.144531 92.757812 L 49.738281 92.757812 L 49.738281 95.605469 L 49.402344 95.714844 L 29.277344 95.714844 L 29.277344 107.433594 L 29.109375 107.546875 L 26.375 107.546875 L 26.261719 107.433594 L 26.261719 89.464844 L 26.542969 87.921875 L 27.0625 86.5625 L 27.84375 85.375 L 28.980469 84.238281 L 29.667969 83.625 L 31.023438 82.9375 L 32.382812 82.601562 Z M 33.109375 82.507812",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.19 0 0 0.19 -25.94 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0.5,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(2,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-360.05, -500.2)",
    d: "M 351.310484 417.590726 L 368.405578 417.590726 L 376.09207 418.703797 L 383.799563 420.509913 L 391.507056 423.303091 L 400.30662 427.50336 L 406.397009 431.40961 L 412.508401 436.008905 L 418.199765 441.007224 L 421.706989 444.493448 L 425.907258 449.806788 L 429.792507 455.099126 L 433.299731 460.790491 L 437.205981 468.897009 L 440.692204 479.208669 L 442.204301 486.391129 L 442.897345 491.704469 L 443.296371 496.996808 L 443.296371 582.703293 L 430.989583 582.997312 L 363.407258 582.997312 L 351.310484 582.598286 L 345.598118 581.905242 L 338.394657 580.393145 L 330.30914 577.599966 L 322.601647 574.092742 L 316.490255 570.606519 L 310.798891 566.700269 L 306.598622 563.193044 L 300.991263 558.005712 L 296.391969 553.007392 L 291.393649 546.601983 L 286.794355 538.894489 L 283.308132 531.691028 L 280.493952 524.004536 L 278.309812 514.805948 L 277.196741 505.607359 L 276.797715 498.403898 L 278.309812 485.00504 L 280.493952 475.491431 L 284.001176 466.292843 L 287.907426 458.606351 L 291.393649 453.293011 L 295.992944 447.202621 L 300.592238 441.910282 L 305.905578 436.890961 L 310.105847 433.404738 L 316.490255 428.805444 L 327.49496 423.093078 L 334.698421 420.299899 L 341.901882 418.493784 L 347.593246 417.401714 Z M 351.310484 417.590726",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.19 0 0 0.19 -24.36 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0.5,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-368.55, -497.65)",
    d: "M 368.489583 447.895665 L 320.606519 547.400034 L 416.498656 547.400034 Z M 368.489583 447.895665",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.19 0 0 0.19 -24.36 1.08)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0.5,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(2,2,2)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-368.55, -506.01)",
    d: "M 368.489583 481.308804 L 344.905074 530.703965 L 392.200101 530.703965 Z M 368.489583 481.308804",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFangoLogo);
export default __webpack_public_path__ + "static/media/Fango_Logo.1bcfab45f064dad677eefcb27ccd2c35.svg";
export { ForwardRef as ReactComponent };